import React from "react";

const Footer = () => {
  return (
    <div className="flex justify-center">
      © 2022 Shopply
      <br className="flex justify-center" />
      (a fictitious e-commerce company for portfolio purposes)
    </div>
  );
};

export default Footer;
